import React, { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import api from "../../../../../config/api";
import { useAuth } from "../../../../../context/ContextApi";
// TODO: verify half hour abstractions
const AvailableTimeButton = styled.button`
  outline: none;
  border: ${({ isActive }) => (isActive ? "1px solid #07C9D4" : "1px solid #6D777D")};
  border-radius: 12px;
  margin: 0 8px 24px;
  font-size: 14px;
  width: 60px;
  background: ${({ isActive }) => (isActive ? "#07C9D4" : "transparent")};
  color: ${({ isActive }) => (isActive ? "white" : "#000")};
`;
export default function ActiveCollaboratorAvailableHours({
  activeCollaborator,
  dateSelected,
  userEstablishment,
  handleServiceChange,
  index,
  serviceDuration,
  hourSelect,
  reserveService,
}) {
  const { userToken } = useAuth();
  const [activeHour, setActiveHour] = useState(hourSelect);
  const [hoursToReserve, setHoursToReserve] = useState([]);

  const getProfessionalReserves = async () => {
    if (!activeCollaborator || !dateSelected) return;
    const config = {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    try {
      const response = await api.get(
        `/professional-reserves/?establishment=${userEstablishment}&date=${dateSelected}&professional=${activeCollaborator}`,
        config
      );
      let newArray = response.data.hours;

      let serviceIndex = index;
      if (reserveService.length > 1) {
        reserveService.map((serviceList, index) => {
          if (
            serviceList.professional === activeCollaborator &&
            serviceList.date === dateSelected &&
            index !== serviceIndex
          ) {
            if (serviceList.hour.length) {
              serviceList?.hour.map((hour) => {
                let indexList = newArray.indexOf(hour);
                newArray.splice(indexList, 1);
              });
            }
          }
        });
      }
      setHoursToReserve(() => newArray);
    } catch (error) {
      console.log("getProfessional error", error);
    }
  };

  const verifyActive = (hour) => {
    if (activeHour.length) {
      return activeHour.includes(hour);
    } else {
      return false;
    }
  };

  const validationHours = (active) => {
    if (active.length && dateSelected && activeCollaborator) {
      const validation = active.every((val) => hoursToReserve.includes(val));
      if (!validation) {
        alert("Horário do serviço maior que o horário disponível");
        return false;
      } else {
        return true;
      }
    }
  };

  useEffect(() => {
    getProfessionalReserves();
  }, [dateSelected, activeCollaborator, userEstablishment]);

  const handleHourClick = (e, hour) => {
    e.preventDefault();

    function getHowManyTimes(value) {
      let time = value;
      let date = new Date("2023-01-01T" + time + "Z");
      let result = (date.getUTCHours() * 60 + date.getUTCMinutes()) / 30;
      let roundedResult = Math.round(result) - 1;
      return roundedResult;
    }

    function formatDateToHour(value) {
      let date = new Date(value);
      let options = { hour: "2-digit", minute: "2-digit" };
      let formattedTime = date.toLocaleTimeString("pt-br", options);
      return formattedTime;
    }

    let howManyTimes = getHowManyTimes(serviceDuration);

    let newArray = [hour];
    var currentTime = new Date("2023-01-01T" + hour);
    for (let index = 0; index < howManyTimes; index++) {
      // Add 30 minutes to the current time
      currentTime.setMinutes(currentTime.getMinutes() + 30);
      const element = formatDateToHour(currentTime.toString());
      newArray.push(element);
    }

    const validation = validationHours(newArray);
    if (validation) {
      setActiveHour(() => newArray);
      handleServiceChange({ target: { name: "hour", value: newArray } }, index);
    } else {
      setActiveHour(() => []);
    }
  };

  return (
    <div className="d-flex scroll-hours my-2">
      {hoursToReserve.length ? (
        <>
          {hoursToReserve.map((hour) => {
            return (
              <AvailableTimeButton
                isActive={verifyActive(hour)}
                onClick={(e) => {
                  handleHourClick(e, hour);
                }}
              >
                {hour}
              </AvailableTimeButton>
            );
          })}
        </>
      ) : (
        <div className="border-top border-bottom p-3 d-flex col-12 justify-content-center">
          <span className="text-cl-auroMetal ff-univanova-medium fz-16 ">
            Nenhum horário disponível para essa data para esse colaborador
          </span>
        </div>
      )}
    </div>
  );
}
